import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge<'prose-size'>({
  extend: {
    classGroups: {
      'prose-size': [{ prose: ['sm', 'base', 'lg', 'xl', '2xl'] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
